import { View, Text as PDFText } from '@react-pdf/renderer'

import { ratePolicyLines } from '../../../statement'
import styles from './styles/index'

interface RatePolicyProps {
  text: string
}

const RatePolicy = ({ text }: RatePolicyProps) => {
  const lines = ratePolicyLines(text)
  if (lines.length === 0) return null

  return (
    <View style={styles.main}>
      <View style={styles.titleContainer}>
        <PDFText style={styles.mainTitle}>قواعد نرخ‌نامه</PDFText>
      </View>
      <View style={styles.mainDiv}>
        {lines.map((line, i) => (
          <PDFText key={i} style={styles.title}>
            {line}
          </PDFText>
        ))}
      </View>
    </View>
  )
}

export default RatePolicy
